import TaxPayerCrud from "../components/tax-payer/TaxPayerCrud";

const TaxPayerPage = () => {
  return <TaxPayerCrud />;
};

export default TaxPayerPage;
